/**
 * Namespaces of the application
 */
export enum Namespace {
    App = 'DSL_CHANGE/APP',
}

/**
 * URL query parameters
 */
export enum QueryNames {
    Product = 'product',
    TargetUrl = 'targetURL',
}

/**
 * Vodafone domains
 */
export enum Domain {
    Vodafone = 'https://eweb8.vfd2-testnet.de',
    ZuhausePlus = 'https://zuhauseplus.vodafone.de',
}

/**
 * CMS placeholder tokens
 */
export enum CmsPlaceholder {
    Name = '$name',
    StairwayMonth = '$month',
    Price = '$price',
    PromoPrice = '$promoPrice',
    DiscountedPrice = '$discountedPrice',
    Download = '$download',
    Upload = '$upload',
    MinDownload = '$minDownload',
    Duration = '$duration',
    ProductName = '$productName',
}
